<template>
    <client-page>
        <div class="sub-visual sub-visual--sv3">
            <v-container>
                <h2 class="sub-visual__title"><span>PARTNERS</span></h2>
            </v-container>
        </div>
        <partners-list></partners-list>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import PartnersList from "@/components/client/ko/board/partners/list.vue"

export default {
    components: {
        ClientPage,
        PartnersList
    },
};
</script>

<style scoped>
</style>